import type { CreateProxyConfigRequest, ProxyIngressContentType } from '@onefootprint/request-types/dashboard';
import type { FormData } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';

const formatCreatePayload = (data: FormData): CreateProxyConfigRequest => {
  const { clientIdentity, name, method, url, accessReason, ingressSettings, pinnedServerCertificates, headers } = data;
  const filteredHeaders = headers.filter(header => header.value && header.name);

  return {
    name,
    method,
    url,
    accessReason,
    clientIdentity:
      clientIdentity.certificate && clientIdentity.key
        ? {
            certificate: clientIdentity.certificate,
            key: clientIdentity.key,
          }
        : undefined,
    headers: filteredHeaders
      .filter(header => !header.secret)
      .map(header => ({ name: header.name, value: header.value })),
    ingressSettings:
      ingressSettings.contentType === 'json'
        ? {
            contentType: ingressSettings.contentType as ProxyIngressContentType,
            rules: ingressSettings.rules,
          }
        : undefined,
    pinnedServerCertificates: pinnedServerCertificates
      .filter(({ certificate }) => certificate)
      .map(({ certificate }) => certificate),
    secretHeaders: filteredHeaders
      .filter(header => header.secret)
      .map(header => ({ name: header.name, value: header.value })),
  };
};

export default formatCreatePayload;
